import _defineProperty from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import { createHOC } from '@jutro/platform';
import { intlMessageShape } from '@jutro/prop-types';
import { ValueComponentWrapper } from './ValueComponentWrapper';
import { FormattedNumber, formattedNumberPropTypes } from './FormattedNumber';
var NumberValueInternal = createHOC({
  component: FormattedNumber,
  wrapper: ValueComponentWrapper,
  displayName: 'NumberValue'
});
var numberValuePropTypes = _objectSpread({
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  path: PropTypes.string,
  tag: PropTypes.string,
  prefix: intlMessageShape,
  suffix: intlMessageShape
}, formattedNumberPropTypes, {
  _rest: PropTypes.any
});
export var NumberValue = function NumberValue(props) {
  return React.createElement(NumberValueInternal, props);
};
NumberValue.propTypes = numberValuePropTypes;
NumberValue.defaultProps = _objectSpread({
  tag: 'div'
}, FormattedNumber.defaultProps);
NumberValue.__docgenInfo = {
  componentName: "NumberValue",
  packageName: "@jutro/components",
  description: "Renders a formatted number using the `tag` property to wrap\nthe value.",
  displayName: "NumberValue",
  methods: [],
  actualName: "NumberValue",
  metadataType: "element",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: true,
      description: "Used to identify the component"
    },
    className: {
      type: {
        name: "string"
      },
      required: false,
      description: "CSS class name for this component"
    },
    path: {
      type: {
        name: "string"
      },
      required: false,
      description: "Hint path to value"
    },
    tag: {
      type: {
        name: "string"
      },
      required: false,
      description: "The html tag to use when rendering the outermost element of this component",
      defaultValue: {
        value: "'div'",
        computed: false
      }
    },
    prefix: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Optional prefix message to be attached in front of the value"
    },
    suffix: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Optional suffix message to be attached at the end the value"
    },
    _rest: {
      type: {
        name: "any"
      },
      required: false,
      description: "Do not set this field directly - this is a placeholder for the rest od properties, same as you can pass to FormattedNumber component"
    }
  },
  composes: ["./FormattedNumber"]
};